<template>
    <wrapper>
        <div class="row header_row">
            <h5><b>My Class Page</b></h5>
            <h6>Exercise List</h6>
        </div>
        <div class="row" v-if="exercise_loading">
            <pre-loader></pre-loader>
        </div>
        <div class="row" v-else>
            <div class="col l8 s10">
                <div class="exercise_list" v-for="item in exercises">
                    <router-link :to="'/exercise/'+item.id"><p>{{item.title}}</p></router-link>
                </div>
            
            </div>
          
        </div>
    </wrapper>
</template>
<script>
export default {
    mounted() {
        this.$store.dispatch("getExercise",{
            subject_id:this.$route.params.subject_id,
            class_id:this.$route.params.class_id
        });
    },
    computed: {
        exercises()
        {
            return this.$store.getters.exercises;
        },
        exercise_loading()
        {
            return this.$store.getters.exercise_loading;
        }
    },
}
</script>
<style lang="scss">
    .header_row 
    {
        padding-top:30px;
    }

    .exercise_list 
    {
        border-bottom:3px solid black;
        padding-bottom:10px;
        p {
            color:black !important;
        }
        
    }
</style>